var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"w-full h-screen"},[_c('div',{staticClass:"container mx-auto flex",staticStyle:{"min-height":"100%"}},[_c('Menu',{staticClass:"w-full my-6"})],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }